import { addTrainingMaterial, addTrainingMaterialMulti, createFolder, deleteFolder, updateFolder, updateTrainingMaterial } from "./actions";
import { designChanges, records } from "./internalAttachable";

import ItemFolderView from "../../../components/ItemFolderView/ItemFolderView.vue"
import ItemListView from "../../../components/ItemListView/ItemListView.vue"
import ItemView from "../../../components/ItemView/ItemView.vue"
import { completeTraining } from "../TrainingMatrix/actions";
import { updateUser } from "../../Home/UserManager/actions";

const dataFields = [{
    "label": "Name",
    "key": "Basic.name"
}, {
    "label": "Email",
    "key": "Basic.email"
}, {
    "label": "Department",
    "key": "Basic.department"
}, {
    "label": "Position",
    "key": "Basic.job_title"
}, {
    "label": "Manager",
    compute({ pageItem, store }) {
        if (!pageItem?.Basic?.ManagerID) return "No manager";
        else return store.state.users[pageItem.Basic.ManagerID].name
    }
}];

const menuActions = [
    {
        "label": "Update User Details",
        "action": updateUser,
        "show": ({ store }) => {
            
            return [store.getters.user?.Security?.General?.UserAdmin === true, "Requires UserAdmin"];
        }
    }
];

export default [{
    "path": "/Matrices/StaffTraining",
    "component": { ...ItemListView },
    "name": "Staff Training Record",
    "meta": {
        "app": "Matrices",
        "sideNav": true,
        "name": "Staff Training Record",
        "storeData": ["Database/Refs/DesignChanges"],
        "sideNav": true,
        "sideNavPosition": 15,
        "sideNavSection": "Staff Training",
        "appSwitcher": false,
        "tableSettings": "UserManager",
        "dataPath": "users",
        "selectionRoute": "Matrices/StaffTraining/{key}",
        filter(item) {
            return item.showTraining && item.main
        },
        "menuActions": [{
            "label": "Add Training Record To Staff Training",
            "action": addTrainingMaterialMulti
        }],
        lock(user) {
            return [user?.Security?.General?.Training !== true, "Cannot view this area"]
        }
    }
}, {
    "path": "/Matrices/TrainingMaterial/",
    "component": { ...ItemFolderView },
    "name": "Training Materials",
    "meta": {
        "app": "Matrices",
        "name": "Training Materials",
        "sideNav": true,
        "sideNavPosition": 15,
        "sideNavSection": "Staff Training",
        "appSwitcher": false,
        "icon": "database",
        "tableSettings": "TrainingMaterials",
        "dataPath": "Home/TrainingMaterial",
        "folderDataPath": "Home/TrainingMaterialFolders",
        "folderRefField": "FolderID",
        "selectionRoute": "Matrices/TrainingMaterial/{ID}",
        lock(user) {
            return [user?.Security?.General?.Training !== true, "Cannot view this area"]
        },
        "rowActions": [{
            "label": "Complete Training Material",
            "action": completeTraining
        },{
            "label": "Download Training Material",
            async action({  rowItem, db }) {
                const url = await db.download(`Database/TrainingMaterial/${rowItem.ID}/${rowItem.File}`);
                window.open(url, "", "width=1280,height=720");
            }
        }, {
            "label": "Update Material", 
            "action": updateTrainingMaterial
        }],
        "menuActions": [{
            "label": "Add Training Material",
            "action": addTrainingMaterial
        }, {
            "label": "Create Folder",
            "action": createFolder,
            "break": true
        }, {
            "label": "Update Folder",
            "action": updateFolder,
            show({ selectedFolder }) {
                return [!!selectedFolder, "Select a folder first"];
            }
        }, {
            "label": "Delete Folder",
            "class": "text-red hover:bg-red",
            "action": deleteFolder,
            show({ selectedFolder }) {
                return [!!selectedFolder, "Select a folder first"];
            }
        }]
    }
}, {
    "path": "/Matrices/TrainingMaterial/:id",
    "component": ItemView,
    "name": "Training Material",
    "meta": {
        "app": "Matrices",
        "name": "Training Material",
        "dataPath": "Home/TrainingMaterial",
        "dataPathOverride": "Home/TrainingMaterial/:id",
        "selectionRoute": "Matrices/TrainingMaterial/{ID}",
        title(item) {
            return `Training Material: ${item.Title}`;
        },
        "attachedItems": {
            
        },
        "dataFields": [{
            "label": "Title",
            "key": "Title"
        }, {
            "label": "Description",
            "key": "Description",
            "class": "md:col-span-2",
            "actionButton": true,
            "actionText": "Download",
            "action": async ({db, item }) => {
                const url = await db.download(`Database/TrainingMaterial/${item.ID}/${item.File}`);
                window.open(url, "__blank");
            }
        }],
        "menuActions": [{
            "label": "Update Material",
            "action": updateTrainingMaterial
        }]
    }
},{
    "path": "/Matrices/StaffTraining/:id",
    "component": ItemView,
    "name": "Staff Member",
    "meta": {
        "app": "Matrices",
        "name": "Staff Member",
        "dataPathOverride": "Userdata/:id/Training",
        "storeData": ["Database/Refs/DesignChanges"],
        title(item) {
            return `Staff: ${item.Basic.name}`;
        },
        itemOverride(item, cd) {
            

            
            const baseData = cd?.store?.state?.users ? cd?.store?.state?.users[cd?.router?.currentRoute?.value?.params?.id] : {};
            
            if(!item) {
                item = {
                    "Records": {}
                };
            };
            
            return {
                "Basic": baseData, 
                "Training": item
            };
        },
        "attachedItems": {
            "Records":{ "attachables":  [records, designChanges]}
        },
        "dataFields": dataFields,
        "menuActions": menuActions
    }
}];
